import { ReactElement, useCallback } from 'react';

import { ConfidentialityMode } from '@dreryk/egabinet-personnel-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { DefaultConfidentialityModeUpdateModal } from './DefaultConfidentialityModeUpdateModal';

type DefaultConfidentialityModeUpdateModalOpenerRenderProps = Readonly<{
   openModal: VoidFunction;
}>;

type DefaultConfidentialityModeUpdateModalOpenerProps = Readonly<{
   mode: ConfidentialityMode | null;
   practitionerId: number;
   onCancel: VoidFunction;
   children: (renderProps: DefaultConfidentialityModeUpdateModalOpenerRenderProps) => ReactElement;
}>;

export const DefaultConfidentialityModeUpdateModalOpener = (
   props: DefaultConfidentialityModeUpdateModalOpenerProps
): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);
   const { onCancel } = props;

   const handleCancel = useCallback(() => {
      closeModal();
      onCancel();
   }, [closeModal, onCancel]);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened && props.mode ? (
            <DefaultConfidentialityModeUpdateModal
               mode={props.mode}
               practitionerId={props.practitionerId}
               onCancel={handleCancel}
               onSuccess={closeModal}
            />
         ) : null}
      </>
   );
};
